export default "__VITE_ASSET__yn4vS6Bx__"